// app/frontend/lib/components/ui/toast/toast.svelte.js

let state = $state({
  message: '',
  type: 'info',
  visible: false
});

let timer;

const clear = () => {
  if (timer) clearTimeout(timer);
  state.visible = false;
};

export const toast = {
  // 核心状态访问
  get current() { return state; },

  // 1. 万能通用显示方法
  show(message, type = 'success', duration = 2000) {
    clear();
    state.message = message;
    state.type = type;
    state.visible = true;

    if (type !== 'loading') {
      timer = setTimeout(clear, duration);
    }
  },

  // 2. 专门处理成功：默认勾选图标
  success(message, duration = 2000) {
    this.show(message, 'success', duration);
  },

  // 3. 专门处理错误：默认感叹号图标
  error(message, duration = 3000) {
    this.show(message, 'error', duration);
  },

  // 4. 加载中：不会自动消失，必须手动调用 hide
  loading(message = "加载中...") {
    this.show(message, 'loading');
  },

  // 5. 信息提示
  info(message, duration = 2000) {
    this.show(message, 'info', duration);
  },

  // 6. 强制隐藏
  hide() {
    clear();
  }
};